import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModalAlertImg from '../../../../../../../common/assets/images/merchants/modal-attention.svg';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import { resources } from '../../../../../resources/resources';

interface InvalidProductForApprovalDialogProps {
  closeDialog: () => void;
  productId: number;
}

export const InvalidProductForApprovalDialog = (
  props: InvalidProductForApprovalDialogProps,
) => {
  const { closeDialog, productId } = props;
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog closeDialog={closeDialog} showCloseIcon className="dialog-m">
      <div className="dialog-content">
        <div className="dialog-image m-dialog-img">
          <img
            src={ModalAlertImg}
            alt={translate(
              resources.products.list.sendForApproval.invalid.title,
            )}
          />
        </div>
        <div className="dialog-title">
          {translate(resources.products.list.sendForApproval.invalid.title)}
        </div>
        <div className="dialog-text centered mb-20">
          {translate(resources.products.list.sendForApproval.invalid.info)}
        </div>
      </div>

      <div className="dialog-actions horizontal">
        <Button className="btn btn-outline" onClick={closeDialog}>
          <span className="btn-text">{translate(resources.abort)}</span>
        </Button>
        <Button
          className="btn btn-solid"
          onClick={() => navigate(`/products/edit/${productId}`)}
        >
          <span className="btn-text">
            {translate(resources.products.list.sendForApproval.invalid.edit)}
          </span>
        </Button>
      </div>
    </Dialog>
  );
};
